import React from "react";

import Applet from "../../Applet";
import ProjectPlanPhaseApprovalTable from "../../../../components/ProjectPlan/ProjectPlanPhaseApprovalTable";

class ProjectPlanPhaseApprovalTableApplet extends Applet {

    render() {
        return <ProjectPlanPhaseApprovalTable applet={this}
                                 pageSize={this.state.PageSize}
                                 placement={this.state.Placement}
                                 columns={this.state.Columns}
                                 title="Approvals"
                                 enterpriseComponent={this.getEnterpriseComponent()}
                                 sort={this.state.Sort}
                                 menu={this.state.Menu}
                                 rowHeight={this.state.RowHeight}
                                 simpleSearch={this.state.SimpleSearch}
                               // enableSort={true}
                               // enableSearch={true}

        />;
    }

    state = {
        Name: "ProjectPlanPhaseApprovalTableApplet",
        Menu: {
            options: [{}],
        },
        RowHeight: 60,
        PageSize: {
            "default": 20,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "EmployeeUserName",
                },
                {
                    id: "Status",
                },
                {
                    id: "SubmissionDatetime",
                },
                {
                    id: "ApprovalDatetime",
                },
                {
                    id: "Actions",
                }
            ]
        },
        Columns: [
            {
                id: "EmployeeUserName",
                width: 240,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Approver",
            },
            {
                id: "Status",
                width: 240,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status",
            },
            {
                id: "SubmissionDatetime",
                width: 240,
                cellRenderer: "Local Date Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Submission Date",
            },
            {
                id: "ApprovalDatetime",
                width: 240,
                cellRenderer: "Local Date Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Approval Date",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": "EmployeeUserName",
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "EmployeeUserName",
                    "DisplayName": "Approver",
                }]
            }
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "EmployeeUserName",
                                    width: 240,
                                    cellRenderer: "Standard Single Cell",
                                    header: "enabled",
                                    headerRenderer: "Standard Single Header",
                                    headerTitle: "Employee",
                                },
                                {
                                    id: "Status",
                                    width: 240,
                                    cellRenderer: "Standard Single Cell",
                                    header: "enabled",
                                    headerRenderer: "Standard Single Header",
                                    headerTitle: "Status",
                                },
                                {
                                    id: "CreateDatetime",
                                    width: 240,
                                    cellRenderer: "Local Date Cell",
                                    header: "enabled",
                                    headerRenderer: "Standard Single Header",
                                    headerTitle: "Created Datetime ",
                                },
                                {
                                    id: "ApprovalDatetime",
                                    width: 240,
                                    cellRenderer: "Local Date Cell",
                                    header: "enabled",
                                    headerRenderer: "Standard Single Header",
                                    headerTitle: "Approval Datetime ",
                                },
                            ]
                        }
                    ]
                }
            },
            Controls: []
        }
    }
}

export default ProjectPlanPhaseApprovalTableApplet;
